// Vite `base` ayarı kök dışında olabildiği için varlık yolları çalışma
// zamanında BASE_URL ile öneklenir.
export const asset = (path: string) => `${import.meta.env.BASE_URL}${path}`;
